<template>
<v-container fluid class="bg1 main--text">
  <v-row v-if="$vuetify.breakpoint.width < 1185 && !show4" justify="center" align="center" no-gutters>
    <!--<v-col md="2" align="center" class="mt-4">
      <v-img class="img-promo" width="150" height="150" style="border-radius: 100px;" src="@/assets/1.png"/>
    </v-col> -->
    <v-img cover width="100%" src="@/assets/landingImage.png"></v-img>
  </v-row>
  <v-row :style="$vuetify.breakpoint.width < 1185 ? 'display: block; text-align: center;' : ''">
    <v-col :class="show4 ? 'mt-4': ''" :style="$vuetify.breakpoint.width < 1185 ? 'display: block; text-align: center;' : ''">
      <v-container
        fluid
        :style="!$vuetify.breakpoint.smAndDown ? 'margin-left: 1cm;' : ''"
        v-if="(!$vuetify.breakpoint.smAndDown && !isStep4 )|| !show4"
        >
        <v-row no-gutters>
          <v-col>
            <p class="headers1" :style="$vuetify.breakpoint.smAndDown ? 'font-size: 48px;' : ''"> Removals in 24 hours. <span class="primary--text">*</span> <br/> Book in seconds.</p>
            <br/>
          </v-col>
        </v-row>
      </v-container>
      <FastQuote
        class="fastQuote par"
        :style="$vuetify.breakpoint.width > 1185 ? 'margin-left: 1cm;' : 'margin-left: 0cm; '"
        @showInfo="toggleInfo"
        ref="fastQuoteComponentRef"
        @step4="checkStep4"/>
    </v-col>
    <v-col
      :style="$vuetify.breakpoint.width < 1185 ? '' : 'margin-top: 2cm;'"
      v-if="$vuetify.breakpoint.width > 1185"
      :cols="$vuetify.breakpoint.width < 1185 ? '' : '6'"
      >
      <v-img contain height="500" src="@/assets/landingImage.png">
        <!--<v-img class="img-promo" width="150" height="150" style="border-radius: 100px; position: relative; left: 1cm;" src="@/assets/1.png"/>-->
      </v-img>
    </v-col>
  </v-row>

  <v-row>
    <v-col align="center">
      <h1 class="primary--text mt-10" style="font-family: Avenir1;">Book any truck size</h1> <br/>
      <p class="headers1"> Use South Africa's fastest furniture removal service </p>
    </v-col>
  </v-row>
  <br>
  <h1 class="text-center" style="font-family: Avenir1;"> Book in 3 easy steps </h1>
  <br>
  <v-row class="mt-5" justify="center">
    <v-col align="center" md="3" @click="scrollToSection('location')">
      <v-img class="bounce-on-hover" width="450" contain src="@/assets/3steps/Group1.svg"></v-img>
    </v-col>
    <v-col align="center" md="3" @click="scrollToSection('location')">
      <v-img class="bounce-on-hover" width="450" contain src="@/assets/3steps/Group2.svg"></v-img>
    </v-col>
    <v-col align="center" md="3" @click="scrollToSection('location')">
      <v-img class="bounce-on-hover" width="450" contain src="@/assets/3steps/Group3.svg"></v-img>
    </v-col>
  </v-row>
  <br><br><br>
  <h1 class="text-center" style="font-family: Avenir1;"> How it works </h1>
  <br>
  <v-row class="mt-5" justify="center">
    <v-col align="center" md="3" @click="navigateToSignUp">
      <v-img class="bounce-on-hover" width="450" contain src="@/assets/InstantBook.png"></v-img>
    </v-col>
    <v-col align="center" md="3" @click="navigateToSignUp">
      <v-img class="bounce-on-hover" width="450" contain src="@/assets/Fulfillment.svg"></v-img>
    </v-col>
    <v-col align="center" md="3" @click="navigateToSignUp">
      <v-img class="bounce-on-hover" width="450" contain src="@/assets/BookPay.svg"></v-img>
    </v-col>
    <v-col align="center" md="3" @click="navigateToSignUp">
      <v-img class="bounce-on-hover" width="450" contain src="@/assets/Guaranteed.svg"></v-img>
    </v-col>
  </v-row>

  <v-row class="white" justify="center">
    <Partners/>
  </v-row>
  <!-- <v-row class="bg1 px-4" id="testimonials">
    <v-row>
        <v-col align="center">
          <h2 class="primary--text mt-12" style="font-family: Avenir1;">Client Testimonials</h2>
          <br/>
          <p class="black--text headers2">
            What clients are saying
          </p>
          <br/>
      </v-col>
    </v-row>
    <WhatClientThink/>
  </v-row> -->

  <!-- <v-row justify="center" v-if="!showPages">
    <v-col align="center">
      <button
        class="primary white--text my-10"
        height="50"
        width="200"
        v-on:click="togglePages"
        style="font-size: 16px; height: 50px; border-radius: 20px; width: 200px;"
        >
        <h2 style="font-family: Avenir1;"> More Info </h2>
    </button>
    </v-col>
  </v-row>

  <div v-if="showPages">
    <br/><br/>
    <v-row class="bg1 px-4">
      <v-col md="6" class="mt-10">
        <v-row>
          <v-col>
            <p class="black--text headers2">Get instant service with our fully online booking system</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <p class="black--text par">Dash Waste allows you to book a variety of waste removal services in just a few clicks. </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2
              @click="check1()"
              :style="show1 ? 'cursor: context-menu; font-family: Avenir1;' : 'cursor: pointer; font-family: Avenir1;'"
              :class="show1 ? 'primary--text' : 'main--text'"
            >
              <ul>
                <li :class="show1 ? 'primary--text' : 'main--text'">
                  Instant Booking
                  <v-icon :class="show1 ? 'primary--text' : 'main--text'"> {{ show1 ? 'mdi-arrow-bottom-right' : 'mdi-arrow-right' }} </v-icon>
                </li>
              </ul>
            </h2>
            <br/>
            <p v-if="show1" class="black--text ml-6 par">
              Our automated booking system will instantly match you with the best available
              services to suite your requirements, all done through our dashboard.
            </p>
            <v-img v-if="show1 && $vuetify.breakpoint.smAndDown" contain src="@/assets/Phone1.svg"></v-img>
            <br v-if="show1"/>

            <h2
              @click="check2()"
              :style="show2 ? 'cursor: context-menu; font-family: Avenir1;' : 'cursor: pointer; font-family: Avenir1;'"
              :class="show2 ? 'primary--text' : 'main--text'"
            >
              <ul>
                <li :class="show2 ? 'primary--text' : 'main--text'">
                  Real-time Service Provider Tracking
                  <v-icon :class="show2 ? 'primary--text' : 'main--text'">{{ show2 ? 'mdi-arrow-bottom-right' : 'mdi-arrow-right' }}</v-icon>
                </li>
              </ul>
            </h2>
            <br/>
            <p v-if="show2" class="black--text ml-6 par">
              You will be instantly matched with one of our trusted approved service providers, with
              the ability to track their location both before and after collecting your waste.
            </p>
            <v-img v-if="show2 && $vuetify.breakpoint.smAndDown" contain src="@/assets/Phone2.svg"> </v-img>
            <br v-if="show2 "/>

            <h2
              @click="check3()"
              :style="show3 ? 'cursor: context-menu; font-family: Avenir1;' : 'cursor: pointer; font-family: Avenir1;'"
              :class="show3 ? 'primary--text' : 'main--text'"
            >
              <ul>
                <li :class="show3 ? 'primary--text' : 'main--text'">
                  Booking Management Dashboard
                  <v-icon :class="show3 ? 'primary--text' : 'main--text'">{{ show3 ? 'mdi-arrow-bottom-right' : 'mdi-arrow-right' }}</v-icon>
                </li>
              </ul>
            </h2>
            <br/>
            <p v-if="show3" class="black--text ml-6 par">
              Our hassle-free booking management dashboard gives you a bird's eye view of
              all of your bookings, both past and present.
            </p>
            <v-img v-if="show3 && $vuetify.breakpoint.smAndDown" contain src="@/assets/Phone3.svg"></v-img>
          </v-col>
        </v-row>
      </v-col>
      <v-col align="right" v-if="!$vuetify.breakpoint.smAndDown" class="mt-12" cols="6">
        <v-img v-if="show1" align="right" style="margin-left: 2cm;" contain src="@/assets/Phone1.svg"/>
        <v-img v-if="show2" align="right" style="margin-left: 2cm;" contain src="@/assets/Phone2.svg"/>
        <v-img v-if="show3" align="right" style="margin-left: 2cm;" contain src="@/assets/Phone3.svg"/>
      </v-col>
    </v-row>
    <br/><br/>

    <v-row justify="center" class="pt-10 main white--text">
      <v-col align="center">
          <h2 class="primary--text" style="font-family: Avenir1;">What we do</h2> <br/>
          <p class="headers1"> Why choose us </p>
          <br/>
          <benefits/>
        </v-col>
    </v-row>
    <br/>

    <v-row class="pt-10 main white--text">
      <v-col align="center">
        <h2 class="primary--text" style="font-family: Avenir1;">We’re constantly expanding our reach</h2> <br/>
        <p :class="$vuetify.breakpoint.smAndDown ? 'headers2 text-start' :'headers2'">
          Our service area is constantly growing, here
          <br v-if="!$vuetify.breakpoint.smAndDown"/>
          are the areas where Dash Waste is currently available
        </p>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="pt-10 main white--text">
      <v-col align="center" md="8">
        <v-img contain src="@/assets/map.svg"/>
      </v-col>
    </v-row>

    <v-row justify="center" class="pt-10 main white--text" :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
      <v-col md="4">
        <v-row>
          <v-col align="start">
            <h2 class="primary--text" style="font-family: Avenir1;">Have questions?</h2> <br/>
            <p class="headers2"> Frequently Asked Questions </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="par">
            <p class="balck--text">
              We pride ourselves on transparency and great customer service, which is why no questions go unanswered.
            </p>
            <br/>
            <p>
              <span style="font-weight: bold; font-size: 16px;"> Have more questions? Call Us </span>
              <a class="primary--text" href="tel:+27722459777" style="text-decoration: none;"> 072 245 9777</a>
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col align="right" md="6" class="par">
        <v-row justify="right">
          <v-col>
            <v-expansion-panels dark popout>
            <v-expansion-panel class="exp">
              <v-expansion-panel-header
                color="cardColour white--text"
                class="exp"
                style="font-family: Avenir3; font-style: normal; font-weight: 400; font-size: 20px; line-height: 20px; height: 80px;"
                >
                How to book?
              </v-expansion-panel-header>
              <v-expansion-panel-content color="main secondary--text" class="exp">
                <v-row justify="center">
                  <v-col align="start">
                    <ul class="secondary--text mt-5">
                        <li> Sign up in 60 seconds with your card or EFT. </li>
                        <li> Enter your waste location. </li>
                        <li> Book different waste types & various products for multiple locations on your dashboard. </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row justify="right">
          <v-col>
            <v-expansion-panels dark popout>
            <v-expansion-panel class="exp">
              <v-expansion-panel-header
                color="cardColour white--text"
                class="exp"
                style="font-family: Avenir3; font-style: normal; font-weight: 400; font-size: 20px; line-height: 20px; height: 80px;"
                >
                How does Dash Waste work?
              </v-expansion-panel-header>
              <v-expansion-panel-content color="main secondary--text" class="exp">
                <HowItWorks/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row justify="right">
          <v-col>
            <v-expansion-panels dark popout>
            <v-expansion-panel class="exp">
              <v-expansion-panel-header
                color="cardColour white--text"
                class="exp"
                style="font-family: Avenir3; font-style: normal; font-weight: 400; font-size: 20px; line-height: 20px; height: 80px;"
                >
                How do I pay?
              </v-expansion-panel-header>
              <v-expansion-panel-content color="main secondary--text" class="exp">
                <Payment/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row justify="right">
          <v-col align="center">
            <router-link style="text-decoration: none;" class="white--text" to="/help">
              <button
                style="width: 200px; height: 10px; border-radius: 15px; font-family: Avenir3; font-style: normal; font-weight: 400; font-size: 20px; line-height: 20px; height: 80px;"
              class="cardColour white--text">More  FAQS</button>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
      <br><br><br>
    </v-row>
    <v-row justify="center" class="primary px-4" :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''" id="installApp">
      <v-col v-if="$vuetify.breakpoint.smAndDown" class="pt-10">
        <v-img style="margin-top: -3cm;" contain src="@/assets/Devices.svg"/>
      </v-col>
      <v-col align="center" v-if="!$vuetify.breakpoint.smAndDown">
        <v-img class="mt-12" src="@/assets/Devices.svg"/>
      </v-col>
    </v-row>
  </div> -->
</v-container>
</template>

<script>

import FastQuote from "@/components/fast-quote/FastQuote";
// import WhatClientThink from "@/components/WhatClientThink";
// import benefits from "@/components/benefits";
// import Payment from "@/components/payment";
// import HowItWorks from "@/components/howItWorks";
import Partners from "@/components/partners.vue";

export default {
  name: 'Homepage',
  components: {
    FastQuote,
    // benefits,
    // WhatClientThink,
    // Payment,
    // HowItWorks,
    Partners
  },
  data (){
    return{
      show1: true,
      show2: false,
      show3: false,
      show4: false,
      isStep4: false,
      showPages: false
    }
  },
  methods: {
    togglePages(){
      this.showPages = true;
    },
    toggleInfo(info){
      if (info){
        this.show4 = true;
      }
    },
    checkStep4(step){
      if(step){
        this.isStep4 = true;
      }
    },
    check1(){
      this.show1 = true;
      this.show2 = false;
      this.show3 = false;
    },
    check2(){
      this.show2 = true;
      this.show1 = false;
      this.show3 = false
    },
    check3(){
      this.show3 = true;
      this.show1 = false;
      this.show2 = false;
    },
    navigateToSignUp(){
      // window.location.href = 'https://app.dashwaste.co.za/signup';
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offset = window.innerHeight / 2 - element.offsetHeight / 2;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth'
        });

        setTimeout(() => {
          this.$refs.fastQuoteComponentRef.focusAddressInput();
        }, 500);
      }
    }
  },
  mounted(){
    scrollTo(0, 0);
  }
}

</script>

<style scoped>
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-40px);
  }
  60% {
    transform: translateY(-25px);
  }
}

.bounce-on-hover:hover {
  animation: bounce 1s;
}
.exp{
  border-radius: 20px;
}
.img-promo{
  transform-origin: top center;
	animation: swing 2s ease infinite;
}
@keyframes swing {
	20% { transform: rotate(15deg); }
	40% { transform: rotate(-10deg); }
	60% { transform: rotate(5deg); }
	80% { transform: rotate(-5deg); }
	100% { transform: rotate(0deg); }
}
.bg1{
  background-image: linear-gradient(to right, white, #D3FAE6);
}
.head1{
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750px;
  font-size: 56px;
  line-height: 64px;
}
.headers1{
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750;
  font-size: 48px;
  line-height: 64px;
}
.headers2{
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750;
  font-size: 48px;
  line-height: 64px;
}
.par{
  font-family: Avenir3;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}
.fastQuote{
  margin-top: -0.6cm;
}
#img1{
  background-image: url("/driver.png");
  background-attachment: fixed;
  background-size: cover;
  background-position-y: center;

}
#img2{
  display: none;
}
.quote{
  background-image: url("/logo-mini.svg");
  background-attachment: scroll;
  background-size: contain;
  background-position: center;
}
.fastquote{
  background: rgba(248, 248, 247, 0.82);
}
@media screen and (max-width: 850px){
  .card1{
    position: relative;
    left: -0cm;
  }

}

@media screen and (max-width: 580px){
  .row1{
    display: block;
  }
  #steps{
    display: block;
  }
  .step{
    display: block;
  }
  #img1{
    background-image: none;
    margin: 0;
  }
  #img2{
    display: block;
    margin-top: -0.5cm;
    border-bottom-right-radius: 90px;
    border-top-left-radius: 90px;
    position: relative;
    left: 0.3cm;
  }
  .card1{
    position: relative;
    top: 0.4cm;
    left: 0cm;
    max-width: 100%;
  }
  .card2{
    position: relative;
    left: 0.2cm;
  }
  .partners{
    display: block;
    margin-bottom: 14cm;
  }


}

</style>
